import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { apiUrl } from '../apiConfig';
import 'bootstrap/dist/css/bootstrap.min.css';

const BRAND = '#facc15';
const BRAND_RGB = '250,204,21';

const fadeUp = { hidden:{ opacity:0, y:24 }, show:{ opacity:1, y:0, transition:{ duration:0.55, ease:[0.22,1,0.36,1] } } };

// Aba "Usuário" é a padrão/ativa — é o login histórico da plataforma, preservado 100%.
// As abas "WhatsApp" e "Email" são extras opcionais (a base de usuários hoje é majoritariamente
// sem telefone/email cadastrado, então usuário+senha continua sendo o fluxo principal).
const TABS = [
  { key: 'usuario', label: 'Usuário' },
  { key: 'whatsapp', label: 'WhatsApp' },
  { key: 'email', label: 'Email' },
];

export default function Login() {
  const { login, loginDireto } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('usuario');

  // Aba Usuário (original)
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  // Aba WhatsApp
  const [telefone, setTelefone] = useState('');
  const [whatsPassword, setWhatsPassword] = useState('');

  // Aba Email
  const [email, setEmail] = useState('');
  const [emailPassword, setEmailPassword] = useState('');

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleTabChange = (key) => {
    setTab(key);
    setError(null);
  };

  const handleSubmitUsuario = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const result = await login(username, password);
    setLoading(false);
    if (result.success) {
      navigate('/app');
    } else {
      setError(result.message || 'Usuário ou senha inválidos');
    }
  };

  const loginComEndpoint = async (endpoint, payload, mensagemErroPadrao) => {
    setError(null);
    setLoading(true);
    try {
      const response = await fetch(apiUrl(endpoint), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      setLoading(false);
      if (data.success && data.token) {
        loginDireto(data.token, data.user);
        navigate('/app');
      } else {
        setError(data.message || mensagemErroPadrao);
      }
    } catch {
      setLoading(false);
      setError('Erro de conexão');
    }
  };

  const handleSubmitWhatsapp = (e) => {
    e.preventDefault();
    loginComEndpoint('/api/login/whatsapp', { telefone, password: whatsPassword }, 'WhatsApp ou senha inválidos');
  };

  const handleSubmitEmail = (e) => {
    e.preventDefault();
    loginComEndpoint('/api/login/email', { email, password: emailPassword }, 'Email ou senha inválidos');
  };

  return (
    <div style={{ minHeight:'100vh', background:'#020617', display:'flex', flexDirection:'column', fontFamily:'Inter, system-ui, sans-serif' }}>
      <style>{`
        * { box-sizing: border-box; }
        .input-dark { background: rgba(255,255,255,0.05) !important; border: 1px solid rgba(255,255,255,0.1) !important; color: #f1f5f9 !important; border-radius: 12px !important; padding: 14px 16px !important; font-size: 0.95rem !important; transition: all 0.2s !important; width: 100%; }
        .input-dark:focus { outline: none !important; border-color: rgba(${BRAND_RGB},0.5) !important; box-shadow: 0 0 0 3px rgba(${BRAND_RGB},0.08) !important; background: rgba(255,255,255,0.07) !important; }
        .input-dark::placeholder { color: rgba(241,245,249,0.3) !important; }
        .btn-brand-full { background:${BRAND}; color:#020617; border:none; border-radius:12px; padding:14px 24px; font-weight:700; font-size:1rem; width:100%; cursor:pointer; transition:all 0.2s; }
        .btn-brand-full:hover:not(:disabled) { transform:translateY(-1px); box-shadow:0 8px 32px rgba(${BRAND_RGB},0.35); }
        .btn-brand-full:disabled { opacity:0.6; cursor:not-allowed; }
        .login-tab { flex:1; text-align:center; padding:10px 8px; border-radius:10px; font-size:0.85rem; font-weight:700; cursor:pointer; border:1px solid transparent; background:transparent; color:rgba(241,245,249,0.45); transition:all 0.2s; }
        .login-tab.active { background:rgba(${BRAND_RGB},0.12); border-color:rgba(${BRAND_RGB},0.3); color:${BRAND}; }
        .login-tab:hover:not(.active) { color:rgba(241,245,249,0.7); }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

      <nav style={{ padding:'0 24px', borderBottom:`1px solid rgba(${BRAND_RGB},0.1)`, background:'rgba(2,6,23,0.97)', backdropFilter:'blur(24px)', position:'sticky', top:0, zIndex:100 }}>
        <div style={{ maxWidth:1200, margin:'0 auto', display:'flex', alignItems:'center', height:60, justifyContent:'space-between' }}>
          <Link to="/" style={{ display:'flex', alignItems:'center', gap:10, textDecoration:'none' }}>
            <div style={{ width:30, height:30, borderRadius:8, background:`rgba(${BRAND_RGB},0.15)`, border:`1px solid rgba(${BRAND_RGB},0.3)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'0.9rem' }}>📊</div>
            <span style={{ fontWeight:800, color:BRAND, fontSize:'1rem' }}>Delator</span>
          </Link>
          <Link to="/" style={{ fontSize:'0.85rem', color:'rgba(241,245,249,0.5)', textDecoration:'none' }}>← Voltar</Link>
        </div>
      </nav>

      <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', padding:'40px 24px', position:'relative' }}>
        <div style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:600, height:400, borderRadius:'50%', pointerEvents:'none', background:`radial-gradient(ellipse, rgba(${BRAND_RGB},0.06) 0%, transparent 65%)` }}/>

        <motion.div initial="hidden" animate="show" variants={{ show:{ transition:{ staggerChildren:0.08 } } }}
          style={{ width:'100%', maxWidth:420, position:'relative', zIndex:2 }}>

          <motion.div variants={fadeUp} style={{ textAlign:'center', marginBottom:36 }}>
            <div style={{ width:56, height:56, borderRadius:16, background:`rgba(${BRAND_RGB},0.12)`, border:`1px solid rgba(${BRAND_RGB},0.25)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.6rem', margin:'0 auto 20px' }}>📊</div>
            <h1 style={{ fontSize:'1.8rem', fontWeight:900, color:'#f1f5f9', marginBottom:8 }}>Entrar no Delator</h1>
            <p style={{ color:'rgba(241,245,249,0.45)', fontSize:'0.9rem', margin:0 }}>Acesse para analisar seus extratos</p>
          </motion.div>

          <motion.div variants={fadeUp}>
            <div style={{ background:'rgba(255,255,255,0.03)', backdropFilter:'blur(20px)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:20, padding:32 }}>

              <div style={{ display:'flex', gap:8, marginBottom:24 }}>
                {TABS.map(t => (
                  <button key={t.key} type="button" className={`login-tab${tab === t.key ? ' active' : ''}`} onClick={() => handleTabChange(t.key)}>
                    {t.label}
                  </button>
                ))}
              </div>

              {tab === 'usuario' && (
                <form onSubmit={handleSubmitUsuario}>
                  <div style={{ marginBottom:18 }}>
                    <label style={{ display:'block', fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.08em' }}>Usuário</label>
                    <input className="input-dark" type="text" placeholder="Seu usuário" value={username} onChange={e => setUsername(e.target.value)} required autoComplete="username"/>
                  </div>
                  <div style={{ marginBottom:24 }}>
                    <label style={{ display:'block', fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.08em' }}>Senha</label>
                    <div style={{ position:'relative' }}>
                      <input className="input-dark" type={showPass ? 'text' : 'password'} placeholder="Sua senha" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" style={{ paddingRight:48 }}/>
                      <button type="button" onClick={() => setShowPass(!showPass)} style={{ position:'absolute', right:14, top:'50%', transform:'translateY(-50%)', background:'transparent', border:'none', color:'rgba(241,245,249,0.4)', cursor:'pointer', fontSize:'1rem', padding:0, lineHeight:1 }}>
                        {showPass ? '🙈' : '👁️'}
                      </button>
                    </div>
                  </div>

                  {error && (
                    <div style={{ background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:10, padding:'12px 16px', marginBottom:20, fontSize:'0.875rem', color:'#fca5a5', display:'flex', alignItems:'center', gap:8 }}>
                      ⚠ {error}
                    </div>
                  )}

                  <button className="btn-brand-full" type="submit" disabled={loading}>
                    {loading ? (
                      <span style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10 }}>
                        <span style={{ width:16, height:16, border:'2px solid rgba(2,6,23,0.3)', borderTopColor:'#020617', borderRadius:'50%', display:'inline-block', animation:'spin 0.7s linear infinite' }}/>
                        Entrando...
                      </span>
                    ) : 'Entrar'}
                  </button>
                </form>
              )}

              {tab === 'whatsapp' && (
                <form onSubmit={handleSubmitWhatsapp}>
                  <div style={{ marginBottom:18 }}>
                    <label style={{ display:'block', fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.08em' }}>WhatsApp</label>
                    <input className="input-dark" type="tel" placeholder="Ex: 47999999999" value={telefone} onChange={e => setTelefone(e.target.value)} required autoComplete="tel"/>
                  </div>
                  <div style={{ marginBottom:24 }}>
                    <label style={{ display:'block', fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.08em' }}>Senha</label>
                    <div style={{ position:'relative' }}>
                      <input className="input-dark" type={showPass ? 'text' : 'password'} placeholder="Sua senha" value={whatsPassword} onChange={e => setWhatsPassword(e.target.value)} required autoComplete="current-password" style={{ paddingRight:48 }}/>
                      <button type="button" onClick={() => setShowPass(!showPass)} style={{ position:'absolute', right:14, top:'50%', transform:'translateY(-50%)', background:'transparent', border:'none', color:'rgba(241,245,249,0.4)', cursor:'pointer', fontSize:'1rem', padding:0, lineHeight:1 }}>
                        {showPass ? '🙈' : '👁️'}
                      </button>
                    </div>
                  </div>

                  {error && (
                    <div style={{ background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:10, padding:'12px 16px', marginBottom:20, fontSize:'0.875rem', color:'#fca5a5', display:'flex', alignItems:'center', gap:8 }}>
                      ⚠ {error}
                    </div>
                  )}

                  <button className="btn-brand-full" type="submit" disabled={loading}>
                    {loading ? (
                      <span style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10 }}>
                        <span style={{ width:16, height:16, border:'2px solid rgba(2,6,23,0.3)', borderTopColor:'#020617', borderRadius:'50%', display:'inline-block', animation:'spin 0.7s linear infinite' }}/>
                        Entrando...
                      </span>
                    ) : 'Entrar'}
                  </button>
                </form>
              )}

              {tab === 'email' && (
                <form onSubmit={handleSubmitEmail}>
                  <div style={{ marginBottom:18 }}>
                    <label style={{ display:'block', fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.08em' }}>Email</label>
                    <input className="input-dark" type="email" placeholder="seu@email.com" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email"/>
                  </div>
                  <div style={{ marginBottom:24 }}>
                    <label style={{ display:'block', fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.08em' }}>Senha</label>
                    <div style={{ position:'relative' }}>
                      <input className="input-dark" type={showPass ? 'text' : 'password'} placeholder="Sua senha" value={emailPassword} onChange={e => setEmailPassword(e.target.value)} required autoComplete="current-password" style={{ paddingRight:48 }}/>
                      <button type="button" onClick={() => setShowPass(!showPass)} style={{ position:'absolute', right:14, top:'50%', transform:'translateY(-50%)', background:'transparent', border:'none', color:'rgba(241,245,249,0.4)', cursor:'pointer', fontSize:'1rem', padding:0, lineHeight:1 }}>
                        {showPass ? '🙈' : '👁️'}
                      </button>
                    </div>
                  </div>

                  {error && (
                    <div style={{ background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:10, padding:'12px 16px', marginBottom:20, fontSize:'0.875rem', color:'#fca5a5', display:'flex', alignItems:'center', gap:8 }}>
                      ⚠ {error}
                    </div>
                  )}

                  <button className="btn-brand-full" type="submit" disabled={loading}>
                    {loading ? (
                      <span style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10 }}>
                        <span style={{ width:16, height:16, border:'2px solid rgba(2,6,23,0.3)', borderTopColor:'#020617', borderRadius:'50%', display:'inline-block', animation:'spin 0.7s linear infinite' }}/>
                        Entrando...
                      </span>
                    ) : 'Entrar'}
                  </button>
                </form>
              )}

            </div>
          </motion.div>

          <motion.div variants={fadeUp} style={{ textAlign:'center', marginTop:24 }}>
            <span style={{ fontSize:'0.85rem', color:'rgba(241,245,249,0.35)' }}>Não tem conta? </span>
            <Link to="/cadastro" style={{ fontSize:'0.85rem', color:BRAND, textDecoration:'none', fontWeight:600 }}>Criar conta grátis</Link>
          </motion.div>
          <motion.div variants={fadeUp} style={{ textAlign:'center', marginTop:12 }}>
            <Link to="/" style={{ fontSize:'0.8rem', color:'rgba(241,245,249,0.25)', textDecoration:'none' }}>← Voltar à página inicial</Link>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}
